import React, { FC } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Result } from "antd";

const NotFound: FC = () => {
  const navigate = useNavigate();

  return (
    <Result
      className="my-12"
      status="404"
      title="Page not found"
      subTitle="The page you are looking for doesn't exist or has been moved."
      extra={
        <Button type="primary" onClick={() => navigate("/")}>
          Back to Events
        </Button>
      }
    />
  );
};

export default NotFound;
